import {
  AppBar,
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import React from "react";
import ButtonDropDown from "../../ButtonDropDown";
import styled from "styled-components";
import SelectView from "../../SelectView";
import TableComponentView from "../../TableComponentView";
import OrderCard from "../WarehouseOrderCard";
import { Masonry } from "@mui/lab";
import { Loop, Send, Undo } from "@mui/icons-material";
import PropTypes from "prop-types";
import ButtonDropDown1 from "../../ButtonDropDown1";
import ButtonDropDownFulfilled from "../../ButtonDropDownFulfilled";

const SearchBox = styled(Box)(({ theme }) => ({
  "& input": {
    padding: "12px",
  },
}));

const CustomAppbar = styled(AppBar)(({ theme }) => ({
  backgroundColor: "#fff !important",
  boxShadow: "none !important",
  "& .tab__class": {
    margin: "10px",
    border: "1px solid #1669bb",
    borderRadius: "5px",
    fontWeight: "700"
  },
  "& .Mui-selected": {
    color: "#fff !important",
    background: "#1669bb"
  }
}))


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3, pb: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}


const ToPickOrderComponent = (props) => {
  // console.log("props-to-pick", props);
  return (
    <div>
      <Box
        pb={3}
        display={"flex"}
        alignItems={"center"}
        flexDirection={props.isMobile ? "column" : "row"}
        justifyContent={"space-between"}
      >
        <Box flex={"1"}>
          <InputLabel>Search</InputLabel>
          <SearchBox display={"flex"}>
            <TextField
              type="search"
              variant="outlined"
              name="searchText3"
              value={props.searchText3}
              onChange={props.handleChangeSearchExpress}
              // onChange={(e) => setSearchText3(e.target.value)}
              onKeyDown={props.handleKeyDownExpress}
              sx={{ width: "300px" }}
              helperText={
                props.searchText3 ? "Press Enter to search to pick orders" : ""
              }
            />
          </SearchBox>
        </Box>
        {props.expressIndex === "to_pick_order_to_be_printed" && (
        <Box flex={"1"}>
          <InputLabel>Fulfill %</InputLabel>

          <FormControl size="small">
            <Select
              //value={}
              sx={{ minWidth: "180px" }}
              onChange={props.handleFulfillChange}
              value={props.fullfillPercentage}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value=""></MenuItem>

              <MenuItem value="0">Blank</MenuItem>
              <MenuItem value="50">Partial Fulfillment</MenuItem>
              <MenuItem value="100">100% Fulfillable</MenuItem>

            </Select>
          </FormControl>
        </Box>
        )}

        <Box textAlign={"center"} flex="1" marginTop={"10px"}>
          <h2>To Be Picked</h2>
        </Box>
        <Box flex={"1"}>
          <Box textAlign={"right"} flex="1">
            {props.currOrderNumbers > 0 ? (
              <>
                <b> New Order : {props.currOrderNumbers}</b>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={props.handleRefetch}
                  style={{ marginLeft: "10px" }}
                >
                  Refetch{" "}
                  <Loop fontSize="small" style={{ marginLeft: "5px" }} />
                </Button>
              </>
            ) : (
              ""
            )}
          </Box>
        </Box>
      </Box>

      <CustomAppbar position="static"
      // style={{ backgroundColor: "#1669bb" }}
      >
        <Tabs
          orientation={props.isMobile ? "vertical" : "horizontal"}
          value={props.expressIndex || "to_pick_order_to_be_printed"}
          onChange={props.handleChangeExpressTab}
          indicatorColor="none"
          // textColor="inherit"
          variant="fullWidth"
          centered
        >
          <Tab label="Order to be Picked" value="to_pick_order_to_be_printed" className="tab__class" />
          <Tab label="Printed Order" value="to_pick_printed_orders" className="tab__class" />
        </Tabs>
      </CustomAppbar>

      {/* Change View */}
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <SelectView handleView={props.handleView} />
        {props.checkedValues.length > 0 ? (
          <Box textAlign={"right"} mb={2} mt={2}>
            {props.expressIndex === "to_pick_order_to_be_printed" ? (
              <ButtonDropDown1
                checkedValues={props.checkedValues.length}
                handleClickPrint={props.handleMultiplePrint}
              />
            ) :
              (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <Button variant="contained" onClick={props.handleMultipleUnpick} size="medium" startIcon={<Undo />} style={{ marginRight: '8px' }}>
                    Unpick Orders
                  </Button>
                  <Button variant="contained" onClick={props.handleMultiplePick} size="medium" endIcon={<Send />} style={{ marginRight: '8px' }}>
                    Pick Orders
                  </Button>
                 
                </div>
              )}
          </Box>
        ) : (
          ""
        )}
      </Box>

      <CustomTabPanel value={props.expressIndex} index={"to_pick_order_to_be_printed"}>
        {!props.loading ? (
          props.view !== 1 ? (
            <>
              <TableComponentView
                columns={props.columns}
                rows={props.filteredData3}
                total={props.totalExpress}
                from={props.fromExpress}
                to={props.toExpress}
                rowsPerPage={props.rowsPerPageExpress}
                page={props.pageExpress}
                handleChangePage={props.handleExpressPage}
                handleChangeRowsPerPage={props.handleExpressRows}
                handleViewDetails={props.handleViewDetails}
                //handlePickupOrder={props.handlePickupOrder}
                handlePrint={props.handlePrint}
                handleCheck={props.handleCheck}
                checkedValues={props.checkedValues}
                openBackdrop={props.openBackdrop}
                backdropNumber={props.backdropNumber}
              />
            </>
          )
            : (
              <>
                <Masonry
                  columns={{ xs: 1, sm: 2, md: 3 }}
                  spacing={3}
                  sx={{ margin: "0", width: "auto" }}
                >
                  {props.filteredData3 &&
                    props.filteredData3.map((order) => (
                      <Box key={order.id}>
                        <OrderCard
                          order={order}
                          //handlePickupOrder={props.handlePickupOrder}
                          handlePrint={props.handlePrint}
                        />
                      </Box>
                    ))}
                </Masonry>
                {props.filteredData3.length ? (
                  <Box
                    alignItems={"center"}
                    justifyContent={"center"}
                    display={"flex"}
                  >
                    <Pagination
                      size="large"
                      count={props.lastPageExpress}
                      page={props.pageExpress}
                      onChange={props.handleExpressPage}
                      variant="outlined"
                      shape="rounded"
                      color="primary"
                    />
                  </Box>
                ) : (
                  ""
                )}
              </>
            ))
          : (
            <Box textAlign={"center"}>
              <CircularProgress />
            </Box>
          )}
      </CustomTabPanel>


      <CustomTabPanel value={props.expressIndex} index={"to_pick_printed_orders"}>
        {!props.loading ? (
          props.view !== 1 ? (
            <>
              <TableComponentView
                columns={props.columns}
                rows={props.filteredData3}
                total={props.totalExpress}
                from={props.fromExpress}
                to={props.toExpress}
                rowsPerPage={props.rowsPerPageExpress}
                page={props.pageExpress}
                handleChangePage={props.handleExpressPage}
                handleChangeRowsPerPage={props.handleExpressRows}
                handleViewDetails={props.handleViewDetails}
                handlePickupOrder={props.handlePickupOrder}
                handleUnpickOrder={props.handleUnpickOrder}
                //handlePrint={props.handlePrint}
                handleCheck={props.handleCheck}
                checkedValues={props.checkedValues}
                openBackdrop={props.openBackdrop}
                backdropNumber={props.backdropNumber}
              />
            </>
          )
            : (
              <>
                <Masonry
                  columns={{ xs: 1, sm: 2, md: 3 }}
                  spacing={3}
                  sx={{ margin: "0", width: "auto" }}
                >
                  {props.filteredData3 &&
                    props.filteredData3.map((order) => (
                      <Box key={order.id}>
                        <OrderCard
                          order={order}
                          handlePickupOrder={props.handlePickupOrder}
                          handleUnpickOrder={props.handleUnpickOrder}
                        //handlePrint={props.handlePrint}
                        />
                      </Box>
                    ))}
                </Masonry>
                {props.filteredData3.length ? (
                  <Box
                    alignItems={"center"}
                    justifyContent={"center"}
                    display={"flex"}
                  >
                    <Pagination
                      size="large"
                      count={props.lastPageExpress}
                      page={props.pageExpress}
                      onChange={props.handleExpressPage}
                      variant="outlined"
                      shape="rounded"
                      color="primary"
                    />
                  </Box>
                ) : (
                  ""
                )}
              </>
            ))
          : (
            <Box textAlign={"center"}>
              <CircularProgress />
            </Box>
          )}
      </CustomTabPanel>

      {/* <CustomTabPanel value={props.expressIndex} index={"to_pick_orders_to_be_printed"}>
                {!props.loading ? (
                    props.view !== 1 ? (
                        <>
                            <TableComponentView
                                columns={props.columns}
                                rows={props.filteredData}
                                total={props.total}
                                from={props.from}
                                to={props.to}
                                rowsPerPage={props.rowsPerPage}
                                page={props.page}
                                handleChangePage={props.handleOrderChangePage}
                                handleChangeRowsPerPage={props.handleOrderChangeRows}
                                handleViewDetails={props.handleViewDetails}
                                handlePickupOrder={props.handlePickupOrder}
                                //handlePickupOrder={props.handlePickOrder}
                                handleUnpickOrder={props.handleUnpickOrder}
                                //handlePrint={props.handlePrint}
                                handleCheck={props.handleCheck}
                                checkedValues={props.checkedValues}
                                openBackdrop={props.openBackdrop}
                                backdropNumber={props.backdropNumber}
                            />
                        </>
                    )
                        : (
                            <>
                                <Masonry
                                    columns={{ xs: 1, sm: 2, md: 3 }}
                                    spacing={3}
                                    sx={{ margin: "0", width: "auto" }}
                                >
                                    {props.filteredData &&
                                        props.filteredData.map((order) => (
                                            <Box key={order.id}>
                                                <OrderCard
                                                    order={order}
                                                    handlePickupOrder={props.handlePickupOrder}
                                                    handleUnpickOrder={props.handleUnpickOrder}
                                                    //handlePrint={props.handlePrint}
                                                />
                                            </Box>
                                        ))}
                                </Masonry>
                                {props.filteredData.length ? (
                                    <Box
                                        alignItems={"center"}
                                        justifyContent={"center"}
                                        display={"flex"}
                                    >
                                        <Pagination
                                            size="large"
                                            count={props.lastPageExpress}
                                            page={props.pageExpress}
                                            onChange={props.handleExpressPage}
                                            variant="outlined"
                                            shape="rounded"
                                            color="primary"
                                        />
                                    </Box>
                                ) : (
                                    ""
                                )}
                            </>
                        ))
                    : (
                        <Box textAlign={"center"}>
                            <CircularProgress />
                        </Box>
                    )}
            </CustomTabPanel> */}
    </div>
  );
};

export default ToPickOrderComponent;
